/* Script per l'apertura dello slider cart*/

document.addEventListener('theme:cart:popdown', function(e) {
  e.stopImmediatePropagation();
  
  const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
  if (!cartDrawer) return;

  // Forza l'inizializzazione del carrello prima di aprire
  document.dispatchEvent(new CustomEvent('theme:cart:init', { bubbles: true }));

  // Aspetta solo che il carrello sia inizializzato
  document.addEventListener('theme:cart:change', function onCartChange() {
    document.removeEventListener('theme:cart:change', onCartChange);
    cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
  }, { once: true });

}, true);